// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7blBZ","footer__grid":"Footer_footer__grid__uA6zB","footer__item__first":"Footer_footer__item__first__hdB5S","bottomMargin":"Footer_bottomMargin__6eZbm"};